module.exports = __webpack_public_path__ + "img/work_titlebg.aabeb35c.png";